import Vue from 'vue'
import Vuex from 'vuex'

import { APP, PARAMS } from '@/localSettings'
import client from '@/mixins/client'
import env from '@/mixins/env'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    app: APP,
    vendors: null,
    currentVendor: 0, // Keeps index of vendors list for Vendor Portal
    token: null,
    refreshToken: null,
    shop: null,
    settings: null,
    appSettings: null,
    portalSettings: null,
    availableMeta: [
      'vendor_consignment_intro',
      'vendor_consignment_review_popup',
      'vendor_consignment_review_popup_write',
      'vendor_product_tag_prefix',
      'mailchimp_subscriber_hash',
      'vendor_enable_order_notifications',
      'vendor_enable_order_notifications_cc',
      'vendor_enable_payout_notifications',
      'currency',
      'vendor_disable_approval_email',
      'consignment_discount_pre_percentage',
      'consignment_flat_rate_apply_discount',
      'consignment_calculate_by_profit',
      'vendor_field_commissions',
      'vendor_field_discount',
      'vendor_field_cost_per_item',
      'vendor_field_sell_price',
      'vendor_field_order_num',
      'vendor_field_order_date',
      'vendor_field_customer_name',
      'vendor_portal_products',
      'vendor_portal_disabled',
      'vendor_portal_theme',
      'vendor_portal_primary_color',
      'vendor_portal_secondary_color',
      'vendor_portal_font_color',
      'vendor_portal_button_text_color',
      'vendor_portal_login_description',
      'vendor_portal_login_title',
      'vendor_portal_logo_url',
      'vendor_portal_logo_title',
      'vendor_portal_terms',
      'vendor_portal_css'
    ],
    metas: null,
    paypal: {
      live_api_client: '',
      live_api_secret: '',
      test_api_client: '',
      test_api_secret: '',
      live_mode: false
    },
    syncing: null
  },
  actions: {
    loadShop: async function ({commit}) {
      let body = document.getElementsByTagName('body')[0]

      let shop = window.location.hostname

      if (PARAMS['override'] && PARAMS['shop_url']) {
        shop = PARAMS['shop_url']
      }

      body.classList.add('loading-area')
      body.classList.add('loading')
      axios({
        method: 'get',
        url: env.api_url() + '/shopify/shop-public/?shop=' + shop
      }).then((response) => {
        commit('setPortalSettings', {settings: response.data})
        body.classList.remove('loading-area')
        body.classList.remove('loading')

        if (this.state.portalSettings.vendor_portal_theme !== 'light') {
          body.classList.remove('light-theme')
        } else {
          body.classList.add('light-theme')
        }
      })
    },
    loadVendor: async function ({commit}) {
      await client.methods.request('get', '/vendors/me/?' + env.params()).then(response => {
        commit('setVendors', {vendors: response.results})
      })

      await client.methods.request('get', '/vendors/app-settings/list/').then(response => {
        commit('setAppSettings', {settings: response.results[0]})
      })

      let metas = {}

      for (let i = 0; i <= this.state.availableMeta.length; i++) {
        metas[this.state.availableMeta[i]] = {
          id: null,
          meta_key: this.state.availableMeta[i],
          meta_value: '',
          shop: null
        }
      }

      await client.methods.request('get', '/shopify/shop-meta/?page_size=200').then(response => {
        let meta = response.results

        for (let i = 0; i < meta.length; i++) {
          let value = meta[i].meta_value

          if (value === 'true') {
            meta[i].meta_value = true
          } else if (value === 'false') {
            meta[i].meta_value = false
          }

          // let body = document.getElementsByTagName('body')[0]

          // if (meta[i].meta_key === 'vendor_portal_theme' && meta[i].meta_value === 'light') {
          //   body.classList.add('light-theme')
          // } else {
          //   body.classList.remove('light-theme')
          // }

          metas[meta[i].meta_key] = meta[i]
        }

        // console.log(metas)

        commit('setMetas', {metas: metas})
      })

      await client.methods.request('get', '/settings/settings/list/').then(response => {
        commit('setSettings', {settings: response.results[0]})
      })
    },
    loadSettings: async function ({commit}) {
      await client.methods.request('get', '/shopify/shops/').then(response => {
        commit('setShop', {shop: response.results[0]})
      })

      await client.methods.request('get', '/settings/settings/list/').then(response => {
        let body = document.getElementsByTagName('body')[0]

        if (response.results !== undefined && response.results.length > 0 && response.results[0].theme === 'light') {
          body.classList.add('light-theme')
        } else {
          body.classList.remove('light-theme')
        }

        commit('setSettings', {settings: response.results[0]})
      })

      await client.methods.request('get', '/vendors/app-settings/list/').then(response => {
        commit('setAppSettings', {settings: response.results[0]})
      })

      let metas = {}

      for (let i = 0; i <= this.state.availableMeta.length; i++) {
        metas[this.state.availableMeta[i]] = {
          id: null,
          meta_key: this.state.availableMeta[i],
          meta_value: '',
          shop: null
        }
      }

      // Payout notifications default to enabled (matches backend behavior)
      metas['vendor_enable_payout_notifications'].meta_value = true

      await client.methods.request('get', '/shopify/shop-meta/?page_size=200').then(response => {
        let meta = response.results

        for (let i = 0; i < meta.length; i++) {
          let value = meta[i].meta_value

          if (value === 'true') {
            meta[i].meta_value = true
          } else if (value === 'false') {
            meta[i].meta_value = false
          }

          metas[meta[i].meta_key] = meta[i]
        }

        commit('setMetas', {metas: metas})
      })

      await client.methods.request('get', '/paypal/settings/list/').then(response => {
        commit('setPayPal', {paypal: response.results[0]})
      })
    },
    updateToken: function ({commit}, data) {
      commit('setToken', {token: data})
    },
    updateRefreshToken: function ({commit}, data) {
      commit('setRefreshToken', {refreshToken: data})
    },
    updateSetting: function ({commit}, data) {
      client.methods.request('put', '/settings/settings/' + this.state.settings.id + '/retrieve-update/', data).then(response => {
        commit('setSettings', {settings: response})
      })
    },
    updateAppSettings: function ({commit}, data) {
      client.methods.request('put', '/vendors/app-settings/' + this.state.appSettings.id + '/retrieve-update/', data).then(response => {
        commit('setAppSettings', {settings: response})
      })
    },
    createMeta: function ({commit}, meta) {
      if (meta.meta_value === null) {
        meta.meta_value = ''
      }

      client.methods.request('post', '/shopify/shop-meta/create/', {
        meta_key: meta.meta_key.toString(),
        meta_value: meta.meta_value.toString()
      }).then(response => {
        commit('setMeta', {meta: meta})
      })
    },
    updateMeta: function ({commit}, meta) {
      if (meta.meta_value === null) {
        meta.meta_value = ''
      }

      if (meta.id !== undefined && meta.id !== null) {
        client.methods.request('put', '/shopify/shop-meta/' + meta.id + '/retrieve-update/', {
          meta_value: meta.meta_value.toString()
        }).then(response => {
          commit('setMeta', {meta: response})
        })
      } else {
        client.methods.request('post', '/shopify/shop-meta/create/', {
          meta_key: meta.meta_key.toString(),
          meta_value: meta.meta_value.toString()
        }).then(response => {
          commit('setMeta', {meta: response})
        })
      }
    },
    updatePayPal: async function ({commit}, paypal) {
      commit('setPayPal', {paypal: paypal})

      await client.methods.request('put', '/paypal/settings/' + paypal.id + '/retrieve-update/', paypal).then(response => {
        commit('setPayPal', {paypal: response})
      })
    }
  },
  mutations: {
    setToken: (state, {token}) => {
      state.token = token
    },
    setRefreshToken: (state, {refreshToken}) => {
      state.refreshToken = refreshToken
    },
    setVendors: (state, {vendors}) => {
      state.vendors = vendors
    },
    setShop: (state, {shop}) => {
      state.shop = shop
    },
    setSettings: (state, {settings}) => {
      state.settings = settings
    },
    setAppSettings: (state, {settings}) => {
      state.appSettings = settings
    },
    setPortalSettings: (state, {settings}) => {
      state.portalSettings = settings
    },
    setMetas: (state, {metas}) => {
      state.metas = metas
    },
    setPayPal: (state, {paypal}) => {
      state.paypal = paypal
    },
    setMeta: (state, {meta}) => {
      let newMetas = state.metas
      let value = meta.meta_value

      if (value === 'true') {
        value = true
      } else if (value === 'false') {
        value = false
      }

      // console.log(meta)

      newMetas[meta.meta_key] = meta
      newMetas[meta.meta_key].meta_value = value

      state.metas = newMetas
    }
  },
  getters: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js